import { motion } from "framer-motion";
import { ArrowRight, Shield, Clock, HandHeart } from "lucide-react";

export const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[100svh] overflow-hidden pt-32 md:pt-40 pb-20"
    >
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0 bg-brand-forest">
        <img
          src="https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&w=2000&q=80"
          alt=""
          className="h-full w-full object-cover opacity-90"
          onError={(e) => { e.currentTarget.style.display = 'none'; }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-forest/95 via-brand-forest/85 to-brand-forest/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-forest/40 via-transparent to-transparent" />
      </div>

      <div className="container-app relative z-10">
        <div className="max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="overline text-brand-gold mb-6"
          >
            J K Awesome Deeds LLC · Florida
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            data-testid="hero-headline"
            className="font-heading text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-brand-cream leading-[1.05] tracking-tight"
          >
            Real solutions for your property.
            <br />
            <span className="italic font-accent text-brand-gold font-normal">
              Compassion for your journey.
            </span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="mt-8 max-w-2xl text-lg md:text-xl text-brand-cream/85 leading-relaxed"
          >
            We help Florida homeowners stop foreclosure, navigate short sales,
            and sell for cash — fast, fairly, and on your terms. Three programs.
            One promise: you are never alone in this.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.5 }}
            className="mt-10 flex flex-col sm:flex-row gap-4"
          >
            <a
              href="#lead-form"
              data-testid="hero-cta-help"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-brand-gold px-7 py-4 text-base font-semibold text-brand-forest transition-all hover:bg-brand-gold-deep hover:-translate-y-0.5 hover:shadow-2xl"
            >
              Get Help With Foreclosure
              <ArrowRight className="h-4 w-4" />
            </a>
            <a
              href="#lead-form"
              data-testid="hero-cta-cash"
              className="inline-flex items-center justify-center gap-2 rounded-md border-2 border-brand-cream/40 bg-brand-cream/5 backdrop-blur-sm px-7 py-4 text-base font-semibold text-brand-cream transition-all hover:bg-brand-cream/15 hover:-translate-y-0.5"
            >
              Get a Cash Offer
              <ArrowRight className="h-4 w-4" />
            </a>
          </motion.div>

          {/* Trust strip */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.7 }}
            className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl"
          >
            {[
              { icon: Shield, label: "Free & Confidential" },
              { icon: Clock, label: "Close in 7 Days" },
              { icon: HandHeart, label: "1,000+ Families Helped" },
            ].map((item, i) => (
              <div
                key={i}
                className="flex items-center gap-3 text-brand-cream/90"
              >
                <item.icon className="h-5 w-5 text-brand-gold flex-shrink-0" />
                <span className="text-sm font-medium">{item.label}</span>
              </div>
            ))}
          </motion.div>
        </div>
      </div>

      {/* Yellow accent stripe — nods to the JC business card */}
      <div className="absolute bottom-0 left-0 right-0 h-2 bg-brand-yellow z-10" />
    </section>
  );
};
